import * as React from 'react';
import {hydrate, render} from 'react-dom';
import {Provider} from 'mobx-react';

import StoryRootStore from './story.RootStore';
import Story from './story';
import {setLangPack} from '../../lang';
import {doClueTracking} from '../../common/clueTracker';

import {registerPwa} from '../../pwa/registerPwa';
import {performanceInitPage} from '../../common/performance';
import {logDetailPvWhenNeeded} from '../../common/logserver';
import {waStep} from '../../common/wastat';

// import VivnAdStory from './temp/vivnAdStory'; // 临时需求，请看该文件

// if (process.env.BROWSER) {
require('normalize.css');
require('@ali/uc-intl-news-jssdk');

// }

function createApp() {
// 恢复js上下文环境：语言包
  setLangPack((window as any)._LANG_PACK);
  // 恢复js上下文环境：root store
  const rootStore: StoryRootStore = new StoryRootStore((window as any)._INITIAL_STATE);

  // await rootStore.articleNewsListStore.getNewsList();
  // 融合html 和 js上下文
  hydrate(
    <Provider rootStore={rootStore}>
      <Story rootStore={rootStore}/>
    </Provider>,
    document.getElementById('app'),
  );
}
window.__FE_TYPE = 'SSR';
console.log('fe_ver', process.env.FE_VER);
performanceInitPage();
createApp();
logDetailPvWhenNeeded();
statStep();
doClueTracking();
registerPwa({isOpen: (window as any)._ENVI_INFO.isPWA});

function statStep() {
  waStep({
    ev_ac: 'step_browser_2',
    fe_type: 'SSR',
    item_id: window._STAT_STORY.item_id,
    siteKey: window._ENVI_INFO.siteKey,
    fe_ver: process.env.FE_VER,
  });
}
